export const navigationConfig = [
  { name: "home", path: "/" },
  { name: "poker", path: "/poker" },
  // { name: "clubGames", path: "/clubGames" },
  { name: "gamingPlatform", path: "/gamingPlatform" },
  { name: "matchPoker", path: "/matchPoker" },
  { name: "gameBox", path: "/gameBox" },
];
